import React from 'react';

const ThemeContext = React.createContext();
const initialState = {
  logo: null,
  logoAlt: null,
  branding: null,
  headerDark: false,
}

function themeReducer(state, action)
{
  switch(action.type) {
    case 'theme/set':
      return {  
        ...action.payload
      }

    default:
      return state;
  }
}

function ThemeProvider({children})
{
  const [state, dispatch] = React.useReducer(themeReducer, initialState);
  const value = [state, dispatch];

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}

function useTheme() {
  const context = React.useContext(ThemeContext)
  if (context === undefined) {
    throw new Error("useTheme must be invoked within a ThemeProvider")
  }

  return context;
}

export {ThemeProvider, useTheme}

